import Vue from "vue";

import VueAWN from "vue-awesome-notifications";

Vue.use(VueAWN, {});
